import { useDispatch } from 'react-redux';

export default function useStoreOrderId() {
    const dispatch = useDispatch();

    const executor = (orderId) => {
        return dispatch({
            type: 'SET_ORDER_ID',
            payload: orderId,
        });
    };

    return executor;
};